import * as React from 'react';

export const CheckBigIcon = () => {
    return (
        <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 5.2907L4.84409 10L12 1" stroke="var(--system-green)" stroke-width="2.5"/>
        </svg>
    );
};
